<div>
  <form #projectionForm="ngForm" novalidate="novalidate" autocomplete="off">
    <div class="row mb-3 justify-content-md-center">
      <div class="col-lg-10 col-md-12">
        <div class="color-secondary-gray font-size-16 font-weight-normal mb-3">
          In the “Future Projections” section, you noted that the Company’s Revenues and/or Income is projected to fluctuate in the upcoming years.  Therefore, a forward looking Discounted Cash Flow (DCF) method will be utilized in this report. (If this is not correct, go back to the “Future Projections” section and select “Yes”.
          <br>
          <br>
          <strong>
            Please provide Revenue forecasts for the following years (add more years if needed, the final year should be the year in which the Revenues reach stability).
          </strong>
        </div>
      </div>
    </div>

    <div class="my-5" *ngIf="currentReport?.LATEST">
      <div class="row">
        <div class="col-lg-3 col-md-4 col-6 table-side-container">
          <div class="header top"></div>
          <div class="header">Projected Revenue</div>
          <div class="header">SDE Margin, %</div>
          <div class="header">Projected SDE</div>
          <div class="header">Present Value of SDE</div>
        </div>

        <div class="col-lg-9 col-md-8 col-6 p-0" *ngIf="currentReport && currentReport.LATEST">
          <div class="d-flex flex-nowrap table__body custom__scroll vertical__Scroll overflow-y-hidden">
            <div class="table-column" *ngFor="let td of currentReport.LATEST.PROJECTION_LIST; let i = index">

              <!-- Year -->
              <div class="table-column-header">
                <span>{{'Year ' + td.YEAR}}</span>
                <button id="{{'projection-table-delete-projection'+i}}" class="button small__button red__button"
                        *ngIf="i > 1" (click)="deleteProjectionDetail(i, td)" [disabled]="currentReport?.isLocked">
                  <img src="../../../../../../assets/images/delete-icon-white.svg" alt="...">
                </button>
              </div>

              <!-- Projected Revenue -->
              <div class="table-column-cell">
                <number-input [(ngModel)]="td.REVENUE"
                  [classes]="'input silent-input'"
                  #REVENUE="ngModel"
                  [disabled]="currentReport?.isLocked"
                  [required]="true"
                  name="REVENU_{{i}}"
                  [allowZero]="true"
                  [clearZero]="false"
                  (blur)="callUpdateAPI('REVENUE', td); showLargeValueWarningModel(td.REVENUE, true)"
                  id="REVENUE_{{i}}"></number-input>
              </div>

              <!-- SDE Margin, % -->
              <div class="table-column-cell position-relative">
                <number-input [(ngModel)]="td.SDE_MARGIN"
                  [classes]="'input silent-input'"
                  [disabled]="currentReport?.isLocked || currentReport.LATEST.PROJECTIONS_ADVANCED"
                  #SDE_MARGIN="ngModel"
                  [required]="false"
                  name="SDE_MARGIN_{{i}}"
                  [max]="2000"
                  (blur)="callUpdateAPI('SDE_MARGIN', td); showLargeValueWarningModel(td.SDE_MARGIN, false)"
                  [allowNegative]="true"
                  id="SDE_MARGIN_{{i}}"></number-input>
                <span class="percentage">%</span>
              </div>

              <!-- Projected SDE -->
              <div class="table-column-cell">
                <div class="value">$ {{td.PROJECTED_SDE | number}}</div>
              </div>

              <!-- Present Value of SDE -->
              <div class="table-column-cell">
                <div class="value">$ {{td.PRESENT_VALUE_SDE | number}}</div>
              </div>

            </div>

            <div class="table-column blue__box" *ngIf="currentReport.LATEST.PROJECTION_LIST.length < 4">

              <div class="table-column-header">
                <button id="add-projection-detail" class="button secondary__button large__button w-100"
                        [disabled]="isAddButtonDisabled || currentReport?.isLocked" (click)="addProjectionDetail()">
                  Add year +
                </button>
              </div>

            </div>

          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-3 col-md-5 mt-4">
          <button id="help-me-calculate-btn" class="button primary__button medium__button half-rounded__button"
            *ngIf="!currentReport.LATEST.PROJECTIONS_ADVANCED" (click)="changeAutomaticallyManually()"
            [disabled]="currentReport?.isLocked">
            Help me Calculate
          </button>

          <button id="manual-overrides-btn" class="button secondary__button blue__bordered__button medium__button half-rounded__button"
            *ngIf="currentReport.LATEST.PROJECTIONS_ADVANCED" (click)="changeAutomaticallyManually()"
                  [disabled]="currentReport?.isLocked">
            Manually Override
          </button>
        </div>
      </div>

      <!-- Cash flow warning -->
      <div class="my-5 cashflow-warning" *ngIf="isCashFlowOverFifteenMillion">
        This tool is intended to value small businesses with cash flow less than $1,500,000.
      </div>
    </div>
  </form>
</div>

<report-footer (buttonClicked)="footerButtonClick($event)" [pageId]="reportPageConst.PROJECTION"
               [nextBtnEnable]="(!projectionForm.invalid || currentReport?.isLocked) && !isCashFlowOverFifteenMillion"></report-footer>
